import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './AnswerKey.css';

function AnswerKey() {
  const location = useLocation();
  const navigate = useNavigate();
  const { questions, examTitle } = location.state || {};

  if (!questions || questions.length === 0) {
    navigate('/config');
    return null;
  }

  return (
    <div className="answer-key-container">
      <div className="container">
        {/* Header */}
        <div className="answer-key-header card">
          <div className="header-icon">📋</div>
          <h1>Gabarito</h1>
          <p className="header-subtitle">
            {examTitle || 'Simulado SAP Commerce Cloud'}
          </p>
          <p className="header-info">
            Total de questões: <strong>{questions.length}</strong>
          </p>
        </div>

        {/* Answer Key Section */}
        <div className="answer-key-section card">
          <h2>Respostas Corretas</h2>
          <div className="questions-list">
            {questions.map((q, index) => {
              const correctAnswers = q.options.filter(opt => opt.isCorrect);

              return (
                <div key={q.id} className="answer-key-item">
                  <div className="answer-key-item-header">
                    <span className="question-number">Questão {index + 1}</span>
                    {q.category && (
                      <span className="question-category">
                        {typeof q.category === 'string' ? q.category : (q.category.name || 'Geral')}
                      </span>
                    )}
                  </div>

                  <p className="question-text">{q.questionText}</p>

                  {q.questionNote && (
                    <div className="question-note">
                      <strong>Nota:</strong> {q.questionNote}
                    </div>
                  )}

                  {/* Show all options */}
                  <div className="options-list">
                    {q.options.map(option => {
                      const isCorrect = option.isCorrect;

                      return (
                        <div
                          key={option.optionLetter}
                          className={`option-item ${isCorrect ? 'correct-option' : ''}`}
                        >
                          <div className="option-content">
                            <span className="option-letter">{option.optionLetter}</span>
                            <span className="option-text">{option.optionText}</span>
                          </div>
                          {isCorrect && (
                            <span className="correct-badge">✓ Correta</span>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {q.explanation && q.explanation.trim() && (
                    <div className="explanation">
                      <strong>💡 Explicação:</strong>
                      <p>{q.explanation}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Actions */}
        <div className="answer-key-actions">
          <button className="btn btn-primary btn-large" onClick={() => navigate('/config')}>
            Nova Configuração
          </button>
          <button className="btn btn-secondary btn-large" onClick={() => navigate('/')}>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  );
}

export default AnswerKey;
